document.addEventListener('DOMContentLoaded', function () {
	document.querySelectorAll('.setItem__option').forEach(function (option) {
		const tabs = option.querySelectorAll('.setItem__option-tab span');
		const thumbs = option.querySelectorAll('.setItem__option-thumb img');
		const total = Math.min(tabs.length, thumbs.length);
		if (total < 2) return;

		// 텍스트 영역: .setItem__option 안에 있으면 그 안에서, 없으면 같은 .setItem 안에서 찾기
		// 바로 아래 자식(ul, div 등 태그 무관)을 A/B 순서대로 전환
		const textScope = option.querySelector('.setItem__option-text') ? option : option.closest('.setItem');
		const textWrap = textScope ? textScope.querySelector('.setItem__option-text') : null;
		const texts = textWrap ? textWrap.children : [];

		let index = [...tabs].findIndex(tab => tab.classList.contains('on'));
		if (index < 0) index = 0;

		function setActive(i) {
			index = i;
			tabs.forEach((tab, idx) => {
				tab.classList.toggle('on', idx === i);
			});
			thumbs.forEach((img, idx) => {
				img.classList.toggle('on', idx === i);
			});
			[...texts].forEach((txt, idx) => {
				txt.classList.toggle('on', idx === i);
			});
		}

		tabs.forEach((tab, idx) => {
			tab.addEventListener('click', function () {
				setActive(idx);
			});
		});

		setActive(index);
	});
});